import React, { createContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
export const EmployeeDetailContext = createContext({});
import { getEmployeeDetail, getCategoryList } from "../../api/Api";
import RoutesContent from "../../constants/routesContent.json";

export const EmployeeDetailContextProvider = ({ children }) => {
  const [employeeDetail, setEmployeeDetail] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [categoryName, setCategoryName] = useState();
  const [dropDownCategoryList, setDropDownCategoryList] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const employeeCode = location?.state;

  const goBack = () => {
    navigate(-1);
  };

  const callGetEmployeeDetail = async () => {
    try {
      const getData = await getEmployeeDetail(employeeCode);
      if (getData.data.status === 200) {
        setEmployeeDetail(getData.data?.data?.employee);
      }
    } catch (error) {
      if (
        error.response.data.status === 401 ||
        error.response.data.status === 400
      ) {
        const errorMessage = error.response.data.message;
        setShowAlert(true);
        setAlertMessage(error.response.data.message);
      } else {
        setShowAlert(true);
        setAlertMessage("Somethingwent wrong");
      }
    }
  };
  const callCategoryList = async () => {
    try {
      const getData = await getCategoryList();
      if (getData.data.status === 200) {
        setDropDownCategoryList(getData.data.data.categories);
      }
    } catch (error) {
      if (
        error.response.data.status === 401 ||
        error.response.data.status === 400
      ) {
        const errorMessage = error.response.data.message;
        setShowAlert(true);
        setAlertMessage(error.response.data.message);
      } else {
        setShowAlert(true);
        setAlertMessage("Somethingwent wrong");
      }
    }
  };
  useEffect(() => {
    callGetEmployeeDetail();
    callCategoryList();
  }, []);

  const providerValue = {
    goBack,
    employeeDetail,
    showAlert,
    setShowAlert,
    alertMessage,

    dropDownCategoryList,
    setDropDownCategoryList,
    categoryName,
    setCategoryName,
  };

  return (
    <EmployeeDetailContext.Provider value={providerValue}>
      {children}
    </EmployeeDetailContext.Provider>
  );
};
